import { Modal, Button, Spinner } from "react-bootstrap";
import { CgCheckO, CgCloseO } from 'react-icons/cg'
export default function ModalConferma(props) {

    // Operazione in corso: la modale resta aperta ma non è più richiudibile né riconfermabile,
    // così l'utente vede che il salvataggio sta girando e non lo lancia una seconda volta.
    const inAttesa = props.inAttesa === true

    const handleClose = () => {
        if (inAttesa)
            return

        props.setMostra(false)
    };

    const handleConferma = () => {
        props.azioneConferma()
    }

    // Su schermi piccoli (Android in verticale) intestazione e pulsanti devono restare sempre
    // visibili: `scrollable` limita l'altezza della finestra e fa scorrere il solo corpo, invece
    // di lasciare che la modale esca dallo schermo. Le regole di .modaleConferma in App.css
    // completano il comportamento sulle larghezze ridotte.
    return (
        <Modal
            show={props.mostra}
            onHide={handleClose}
            centered
            scrollable
            dialogClassName="modaleConferma"
            backdrop={props.mode === "success" || inAttesa ? "static" : "true"}
            keyboard={!inAttesa}
        >
            <Modal.Header>
                <Modal.Title className="w-100 text-center">
                    {props.mode === 'danger' || props.mode === 'error' ?
                        <CgCloseO className="me-2 text-danger" />
                        :
                        <CgCheckO className="me-2 text-success" />
                    }
                    {props.titolo}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={props.bodyAlign}>
                {inAttesa ?
                    <div className="d-flex flex-column align-items-center">
                        <Spinner animation="border" variant="primary" role="status" className="mb-3">
                            <span className="visually-hidden">Operazione in corso...</span>
                        </Spinner>
                        <span>{props.messaggioAttesa ? props.messaggioAttesa : "Operazione in corso, attendere..."}</span>
                    </div>
                    :
                    props.messaggio
                }
            </Modal.Body>
            <Modal.Footer className={props.mode !== "success" && props.mode !== "error" ? "d-flex justify-content-between" : "d-flex justify-content-center"}>
                {
                    props.mode !== "success" &&
                    props.mode !== "error" &&
                    <Button variant="outline-secondary"
                        disabled={inAttesa}
                        onClick={() => {
                            handleClose()
                            props.azioneAnnulla &&
                                props.azioneAnnulla()
                        }}>
                        {props.btnAnnulla}
                    </Button>
                }
                {
                    props.btnConferma &&
                    <Button variant="primary" onClick={handleConferma} disabled={inAttesa}>
                        {inAttesa ?
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                Attendere...
                            </>
                            :
                            props.btnConferma
                        }
                    </Button>
                }
            </Modal.Footer>
        </Modal >
    )
}
